import React from 'react';
import { noop, map } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionList as ActionListView } from 'modules/action-list';
 *
 * // render
 * <ActionListView propName='propValue'/>
 */
export const actionList = ( props ) => {
    return (
        <div className='ui-action-list'>
            <div className='ui-action-list__actions'>
                {
                    map( props.actions, ( action ) => {
                        return (
                            <div key={ action.name } className='ui-action-list__actions__action' onClick={ () => {
                                props.closePopover();
                                props.onActionClick( action );
                            } }>

                                {/* icon */}
                                <div className='ui-action-list__actions__action__icon'>
                                    <Icon
                                        name={ action.iconName }
                                        width={ 16 }
                                        height={ 16 }
                                        fill={ props.disabled ? '#7a7a7a' : THEME.themeColorPrimary2 }
                                    />
                                </div>

                                <div className='ui-action-list__actions__action__title'>
                                    { getLabel( action.title ) }
                                </div>
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
actionList.displayName = 'actionList';

// set default props
actionList.defaultProps = {
    actions: [],
    onActionClick: noop,
    closeOnActionClick: true,
};

// prop types
actionList.propTypes = {};
